module.exports = __webpack_public_path__ + "img/p7.c2ea1b17.png";